import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button, Icon } from 'semantic-ui-react';
import * as utils from './eventUtils/eventFormUtils.jsx';

const styles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    marginBottom: '5px',
  },
  sectionTitle: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#569556',
    marginBottom: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '15px',
  },
  submitButton: {
    backgroundColor: '#569556',
    color: 'white',
  },
};

class EventForm extends React.Component {
  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };

  render() {
    return (
      <form onSubmit={this.props.handleSubmit(this.onSubmit)} className="ui form error" style={styles.form}>
        {/* Event Details Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Event Details</div>
          <div style={styles.fieldRow}>
            <Field name="event_name" component={utils.renderInput} label="Event Name" />
            <Field name="event_club" component={utils.renderInput} label="Club" />
          </div>
        </div>

        {/* Location Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Location</div>
          <div style={styles.fieldRow}>
            <Field name="event_location" component={utils.renderInput} label="Event Location" />
          </div>
        </div>

        {/* Date Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Date</div>
          <div style={styles.fieldRow}>
            <Field name="event_year" component={utils.renderSelectYear} label="Year" />
            <Field name="event_month" component={utils.renderSelect} label="Month" />
            <Field name="event_day" component={utils.renderSelectDay} label="Day" />
          </div>
        </div>

        {/* Time Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Start Time</div>
          <div style={styles.fieldRow}>
            <Field name="event_hour" component={utils.renderSelectHour} label="Hour" />
            <Field name="event_min" component={utils.renderSelectMin} label="Minute" />
          </div>
        </div>

        {/* Status Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Status</div>
          <div style={styles.fieldRow}>
            <Field name="event_activation_status" component={utils.renderEventActivation} label="Activation Status" />
            <Field name="event_registration" component={utils.renderEventRegistration} label="Registration" />
          </div>
        </div>

        {/* Notes Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Additional Notes</div>
          <Field name="notes" component={utils.renderTextArea} label="Notes" />
        </div>

        <Button type="submit" style={styles.submitButton} size="large">
          <Icon name="check" /> Save Event
        </Button>
      </form>
    );
  }
}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.event_location) {
    errors.event_location = 'You must enter game location';
  }

  if (!formValues.event_name) {
    errors.event_name = 'You must enter game name';
  }

  if (!formValues.event_day) {
    errors.event_day = 'You must enter day of month';
  }
  if (!formValues.event_hour) {
    errors.event_hour = 'You must enter start hour';
  }
  if (!formValues.event_min) {
    errors.event_min = 'You must enter start minute';
  }

  if (!formValues.event_year) {
    errors.event_year = 'You must enter year';
  }
  if (!formValues.event_club) {
    errors.event_club = 'You must enter club name';
  }

  if (!formValues.event_activation_status) {
    errors.event_activation_status = 'You must enter activation status';
  }

  if (!formValues.event_registration) {
    errors.event_registration = 'You must select registration state';
  }

  if (!formValues.event_month) {
    errors.event_month = 'You must enter month';
  }
  return errors;
};

export default reduxForm({
  form: 'eventForm',
  validate,
})(EventForm);
